import { FormattedMessage } from "react-intl";
import { ReactNode } from "react";
import { useIntl } from "react-intl";
import { PayPhoneIcon } from "@/public/icons/PayPhoneIcon";
import styles from "./ContactBlock.module.scss";

export type ContactBlockProps = {
  email: string;
  phone: string | null;
};

export const ContactBlock = ({ email, phone }: ContactBlockProps) => {
  const intl = useIntl();

  return (
    <div className={styles.contact}>
      <p className={styles.text}>
        {intl.formatMessage({ id: "faqContactText" })}
      </p>
      {phone != null && (
        <div className={styles.phone}>
          <a href={`tel:${phone}`}>
            <PayPhoneIcon phoneNumber={phone} />
          </a>
        </div>
      )}
      <div className={styles.email}>
        <FormattedMessage
          id="faqEmail"
          values={{
            b: (chunks: ReactNode[]) => (
              <span className={styles.bold}>{chunks}</span>
            ),
            link: (chunks: ReactNode[]) => (
              <a href={`mailto:${chunks.toString()}`}>{chunks}</a>
            ),
            email: email,
          }}
        />
      </div>
    </div>
  );
};
